import React from 'react';

// Is shown when the server returns an error code
// This is only the case when something crashes on the server
export default class ErrorView extends React.Component {
    render() {
        return (
            <div>
                <h1>Error</h1>
                <p>Sorry about this, please go back to the home page and log in again, here are some details:</p>
                <p>{this.props.error + ""}</p>
                <span>&#8594;</span><a className="link-button-menu" href='/game/dashboard'>Dashboard</a>
                <br />
                <span>&#8594;</span><a className="link-button-menu" href='/'>Login Screen</a>
            </div>
        );
    }
}
